import React, { useState, useEffect, useCallback } from 'react';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { showLoader } from 'utils/commonUtils';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboard } from './services/dashboardApi';
import { getDashboardDetails } from '../store/dashboardSlice';
import DashboardLaunch from './components/dashboardLaunch/DashboardLaunch';
import DashboardCalendar from './components/dashboardCalendar/DashboardCalendar';
import DashboardMyClasses from './components/dashboardMyClasses/DashboardMyClasses';
import DashboardAnnouncements from './components/dashboardAnnouncements/DashboardAnnouncements';
import DashboardTutoringSessions from './components/dashboardTutoringSessions/DashboardTutoringSessions';
import {
  DashboardCard,
  DashboardLeftGrid,
  DashboardSubHeader,
  SubHeadingTypography,
} from 'components/Ui/styled';
import FormPopup, { getFormPopupKey } from './components/formPopup/FormPopup';
//import SkillifyPopup, { SKILLIFY_DISMISSED_KEY } from './components/skillifyPopup/SkillifyPopup';

const MainDashboard = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [showFormPopup, setShowFormPopup] = useState(false);
  const studentType = useSelector((state) => state.dashboard?.profile?.studentType);
  const username = useSelector((state) => state.dashboard?.username);
  const formPopupKey = getFormPopupKey(username);

  useEffect(() => {
    if (
      !isLoading &&
      username &&
      studentType === 'Online' &&
      localStorage.getItem(formPopupKey) !== 'true'
    ) {
      setShowFormPopup(true);
    }
  }, [isLoading, username, studentType, formPopupKey]);

  const tutoringSessions = useSelector(
    (state) => state.dashboard.tutoringSessions
  );
  const hasTutoringSessions = tutoringSessions?.length > 0;

  const fetchDashboard = useCallback(async () => {
    const dashboardData = await getDashboard();
    dispatch(getDashboardDetails(dashboardData));

    // const dismissed = localStorage.getItem(SKILLIFY_DISMISSED_KEY) === "true";
    // if (gradeLevel >= 7 && gradeLevel <= 12 && studentType === "Online" && !dismissed) {
    //   setShowSkillify(true);
    // }

    setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return (
    <>
      <FormPopup
        open={showFormPopup}
        onClose={() => setShowFormPopup(false)}
        storageKey={formPopupKey}
      />
      {/*<SkillifyPopup open={showSkillify} onClose={() => setShowSkillify(false)} />*/}
      {isLoading ? (
        showLoader()
      ) : (
        <>
          <Grid container spacing={3}>
            {/* <DashboardLeftGrid item xs={12} sm={6}> */}
            {/* <AnnouncementCard>
                <HeadingTypography variant="h6">
                  Announcements
                </HeadingTypography>
                <DashboardAnnouncements />
              </AnnouncementCard> */}
            {/* <Grid item md={6}>
                <DashboardSubHeader>
                  <SubHeadingTypography variant="h6">
                    Announcements
                  </SubHeadingTypography>
                </DashboardSubHeader>
                <DashboardCard>
                  <DashboardAnnouncements />
                </DashboardCard>
              </Grid>
              <MDBox pt={3.5}></MDBox> */}

            {/* <DashboardMyClasses /> */}
            {/* <Grid item md={6}>
                <DashboardSubHeader>
                  <SubHeadingTypography variant="h6">
                    My Classes
                  </SubHeadingTypography>
                </DashboardSubHeader>
                <DashboardCard>
                  <DashboardMyClasses />
                </DashboardCard>
              </Grid>
              <MDBox pt={3.5}></MDBox>

              <Grid item md={6}>
                <DashboardSubHeader>
                  <SubHeadingTypography variant="h6">
                    Launch
                  </SubHeadingTypography>
                </DashboardSubHeader>
                <DashboardCard>
                  <DashboardLaunch />
                </DashboardCard>
              </Grid>
              <MDBox pt={3.5}></MDBox>

              <Grid item md={6}>
                <DashboardSubHeader>
                  <SubHeadingTypography variant="h6">
                    Tutoring Sessions
                  </SubHeadingTypography>
                </DashboardSubHeader>
                <DashboardCard>
                  <DashboardTutoringSessions />
                </DashboardCard>
              </Grid> */}
            {/* </DashboardLeftGrid> */}

            {/* ROW 1 */}
            <DashboardLeftGrid item xs={12} sm={7}>
              <Grid container spacing={3}>
                {/* Announcements */}
                <Grid item xs={12}>
                  <DashboardSubHeader>
                    <SubHeadingTypography variant="h6">
                      📢 Announcements
                    </SubHeadingTypography>
                  </DashboardSubHeader>
                  <DashboardCard>
                    <DashboardAnnouncements />
                  </DashboardCard>
                </Grid>

                {/* Launch */}
                <Grid item xs={12}>
                  <DashboardSubHeader>
                    <SubHeadingTypography variant="h6">
                      🚀 Launch
                    </SubHeadingTypography>
                  </DashboardSubHeader>
                  <DashboardCard>
                    <DashboardLaunch />
                  </DashboardCard>
                </Grid>
              </Grid>
            </DashboardLeftGrid>

            <Grid item xs={12} sm={5} style={{ display: 'flex' }}>
              <Card style={{ width: '100%', height: '100%' }}>
                <DashboardSubHeader>
                  <SubHeadingTypography variant="h6">
                    📅 School Calendar
                  </SubHeadingTypography>
                </DashboardSubHeader>
                <DashboardCalendar />
              </Card>
            </Grid>

            {/* ROW 2 */}
            <DashboardLeftGrid item xs={12} sm={7}>
              <Grid container spacing={3}>
                {/* My Classes */}
                <Grid item xs={12}>
                  <DashboardSubHeader>
                    <SubHeadingTypography variant="h6">
                      📚 My Classes
                    </SubHeadingTypography>
                  </DashboardSubHeader>
                  <DashboardCard>
                    <DashboardMyClasses />
                  </DashboardCard>
                </Grid>
              </Grid>
            </DashboardLeftGrid>

            {hasTutoringSessions && (
              <Grid item xs={12} sm={5}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <DashboardSubHeader>
                      <SubHeadingTypography variant="h6">
                        🎓 Scheduled Tutoring Sessions
                      </SubHeadingTypography>
                    </DashboardSubHeader>
                    <DashboardCard>
                      <DashboardTutoringSessions />
                    </DashboardCard>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/*<Grid item xs={12} sm={5}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <DashboardSubHeader>
                    <SubHeadingTypography variant="h6">
                      Summer School Hours and Zoom Link
                    </SubHeadingTypography>
                  </DashboardSubHeader>
                  <DashboardCard>
                    <MDTypography p={3} variant="h6" fontWeight="light">
                  The computer lab will be open Mondays - Thursdays from 10 AM - 2 PM. <br />
                  Teachers will be on campus for help and computers will be available for students to use. <br /><br />
                  Zoom Link - <Link sx={{color:'blue'}} href={"https://us06web.zoom.us/j/5904621714"} target="_blank">
                    https://us06web.zoom.us/j/5904621714
                  </Link>
                </MDTypography>
                  </DashboardCard>
                </Grid>
              </Grid>
            </Grid>*/}

{/*            
            <Grid item xs={12} sm={5}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <DashboardSubHeader>
                    <SubHeadingTypography variant="h6">
                      🎓 Tutoring Sessions
                    </SubHeadingTypography>
                  </DashboardSubHeader>
                  <DashboardCard>
                    <DashboardTutoringSessions />
                  </DashboardCard>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <HeadingTypography variant="h6">Summer School Hours and Zoom Link</HeadingTypography>
                <MDTypography p={3} variant="h6" fontWeight="light">
                  The computer lab will be open Mondays - Thursdays from 10 AM - 2 PM. <br />
                  Teachers will be on campus for help and computers will be available for students to use. <br /><br />
                  Zoom Link - <Link sx={{color:'blue'}} href={"https://us06web.zoom.us/j/5904621714"} target="_blank">
                    https://us06web.zoom.us/j/5904621714
                  </Link>
                </MDTypography>


              </Card>
            </Grid>
*/}          
          </Grid>
          <MDBox pt={3.5}></MDBox>
          <Grid container spacing={3}>
            {/*
            <DashboardLeftGrid item xs={12} sm={6}>
              <DashboardSubHeader>
                <SubHeadingTypography variant="h6">
                  Upcoming due dates
                </SubHeadingTypography>
              </DashboardSubHeader>
              <DashboardCard>
                <DashboardUpcomingDueDates />
              </DashboardCard>
            </DashboardLeftGrid>
            <Grid item xs={12} sm={12}>
              <DashboardSubHeader>
                <SubHeadingTypography variant="h6">Launch</SubHeadingTypography>
              </DashboardSubHeader>
              <DashboardCard>
                <DashboardLaunch />
              </DashboardCard>
            </Grid>
            */}
          </Grid>
        </>
      )}
    </>
  );
};

export default MainDashboard;
